import { useState, useEffect, useRef } from "react";
import "./style.css";
import { ReactComponent as MenuIcon } from "../../Assets/images/menuIcon.svg";
import { ReactComponent as BellIcon } from "../../Assets/images/bellIcon.svg";
import { ReactComponent as Close } from "../../Assets/images/close.svg";
import { CircularProgressbarWithChildren, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { signOut } from "../../Services/auth";
import { getUnreadNotificationCount } from "../../Services/notificationAris";
import NotificationContainer from "../NotificationContainer/NotificationContainer";
import ReferralPopup from "../../Pages/ReferralPopup";
import ChatModal from "../ChatModal/ChatModal";
import { useHeader } from "../../Providers/HeaderContextProvider";
import { useFCMNotifications } from "../../Contexts/FCMNotificationContext";
import MenuComponent from "./MenuComponent";
import Loader from "react-js-loader";
import SessionSelection from "../../Pages/RelationShip/LiveSession/SessionSelection";


function CircularImage({ }) {
  const { profileContent } = useHeader();

  return (
    <CircularProgressbarWithChildren
      value={profileContent?.profile_completion_percent || 0}
      strokeWidth={8}
      className={`header-progress`}
      styles={buildStyles({
        strokeLinecap: "butt",
        pathColor: " #BCF5A7",
        textColor: "#f88",
        trailColor: "#274079",
        backgroundColor: "#3e98c7",
      })}
    >
      <div>
        {profileContent?.profile_pic_url ? (
          <img
            src={profileContent?.profile_pic_url}
            alt="Circular"
            width={32}
            height={32}
            className="circular-image"
          />
        ) : (
          <div
            className="header-profile-circle-image"
            style={{ width: "2.50 rem", height: "2.50 rem" }}
          >
            {`${profileContent?.first_name?.[0]?.toUpperCase() || ""}${profileContent?.last_name?.[0]?.toUpperCase() || ""
              }`}
          </div>
        )}
      </div>
    </CircularProgressbarWithChildren>
  );
}

const aboutAris = () => {
  window.location.href = "/about-aris";
};
const termOfUse = () => {
  window.location.href = "/term-of-use";
};
const privacyPolicy = () => {
  window.location.href = "/privacy-policy";
};

const handleNavigate = () => {
  window.location.href = "/dashboard";
};

const handleNavigateMyRelationship = () => {
  window.location.href = "/manageRelationship";
};

const onboarding = () => {
  window.location.href = "/customer-support";
};

const gotoManageMembership = () => {
  window.location.href = "/manageMembership";
};

const onboardingfunc = () => {
  onboarding();
};

const MyRelationshipfunc = async () => {
  handleNavigateMyRelationship();
};

function HeaderComponent({ isCoachingActive }) {
  const {
    headerContentRightSideContent,
    profileContent,
    isChatHistoryOpen,
  } = useHeader();
  
  const [showMenu, setShowMenu] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const [selectedSessionId, setSelectedSessionId] = useState(null);
  const [showHeaderLogo, setShowHeaderLogo] = useState(true);

  const calendarRef = useRef(null);
  const notificationRef = useRef(null);
  const intervalRef = useRef(null);

  // FCM integration via context
  const { onMessageReceived, onNotificationClicked, isInitialized, incrementNotificationCount } = useFCMNotifications();

  const fetchUnreadCount = async (force = false) => {
    try {
      // Guard by route for polling; but allow forced refresh from events
      if (!force && !isNotificationRoute()) {
        return;
      }
      const count = await getUnreadNotificationCount();
      setNotificationCount(count || 0);
    } catch (e) {
      setNotificationCount(0);
      console.error("Error fetching unread notification count:", e);
    }
  };

  const isNotificationRoute = () => {
    try {
      const pathname = window?.location?.pathname || "";
      return ["/chat", "/dashboard", "/dialogues"].some((p) => pathname.startsWith(p));
    } catch (_) {
      return false;
    }
  };

  useEffect(() => {
    // Start interval on mount; each tick checks route guard before calling API
    const intervalMs = Number(process.env.REACT_APP_NOTIFICATION_INTERVAL) || 3600000;
    // Immediate attempt (will no-op if route not allowed)
    fetchUnreadCount();
    intervalRef.current = setInterval(fetchUnreadCount, intervalMs);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  // Listen to FCM events to update bell count immediately via context
  useEffect(() => {
    if (!isInitialized) return;

    // On message received in foreground, optimistically increment and refresh
    const unSubMsg = onMessageReceived(() => {
      setNotificationCount((c) => (typeof c === "number" ? c + 1 : 1));
      // Refresh from server shortly after to stay accurate
      setTimeout(() => fetchUnreadCount(true), 1000);
    });

    // On notification clicked, refresh count (it might mark as read)
    const unSubClick = onNotificationClicked(() => {
      setTimeout(() => fetchUnreadCount(true), 500);
    });

    return () => {
      unSubMsg();
      unSubClick();
    };
  }, [isInitialized, onMessageReceived, onNotificationClicked]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotification(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setError("");
    }, 3000);
  }, [error]);

  // Hide the header while a voice session is running, so the session owns the
  // screen. The Aris tab now runs its voice session on /dashboard itself, so that
  // path counts alongside the older /coach routes. No need to inspect `?mode=`:
  // only a voice session sets isCoachingActive, and both conditions must hold.
  useEffect(() => {
    const pathname = window?.location?.pathname || "";
    const isVoiceSurface =
      pathname.startsWith("/coach") || pathname.startsWith("/dashboard");

    setShowHeaderLogo(!(isVoiceSurface && isCoachingActive));
  }, [isCoachingActive]);

  // The home tab bar's Menu tab opens this menu. The bar lives inside the
  // router and this header does not, so the ask arrives as a window event.
  useEffect(() => {
    const onToggle = () => {
      if (isCoachingActive) return;
      setShowNotification(false);
      setShowCalendar(false);
      setShowMenu((prev) => !prev);
    };
    window.addEventListener("aris:toggle-menu", onToggle);
    return () => window.removeEventListener("aris:toggle-menu", onToggle);
  }, [isCoachingActive]);

  // Where the tab bar is up it carries Menu, so the header's own hamburger
  // steps back (Figma 9862:23510 shows only the bell). Tracked off the body
  // flag the bar sets, since the bar decides when it exists.
  const [tabbarUp, setTabbarUp] = useState(
    () => typeof document !== "undefined" && document.body.classList.contains("has-home-tabbar")
  );
  useEffect(() => {
    const read = () => setTabbarUp(document.body.classList.contains("has-home-tabbar"));
    const observer = new MutationObserver(read);
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    read();
    return () => observer.disconnect();
  }, []);

  // Hide header for admin routes - check AFTER all hooks
  const pathname = window?.location?.pathname || "";
  if (pathname.startsWith("/admin")) {
    return null;
  }

  const closeMenu = (e) => {
    e.stopPropagation();
    setShowMenu(false);
  };

  const sideMenuHandle = () => {
    setShowNotification(false);
    setShowCalendar(false);
    setShowMenu((prev) => !prev);
  };


  const signOutFunction = async () => {
    setLoading(true);
    await signOut()
      .then(() => {
        handleNavigate();
      })
      .catch((err) => {
        setError("Something went wrong please try again");
      })
      .finally(() => setLoading(false));
  };

  // Hide entire header when coaching session is active on coach route
  if (!showHeaderLogo) {
    return null;
  }

  return (
    <div className="header-component-hero-container">
      <ChatModal
        onClose={() => setShowLogoutPopup(false)}
        width={"300px"}
        height={"auto"}
        padding={"0px"}
        isOpen={showLogoutPopup}
        // isOpen={true}
        children={
          <div>
            <div className="logout-modal-container">
              <div className="logout-modal-header">Log Out</div>
              {loading && (
                <div className="loader-df-container">
                  <Loader
                    type="spinner-cub"
                    bgColor={"#2D50A7"}
                    color={"#3D6DEB"}
                    // title={"spinner-cub"}
                    size={45}
                  />
                </div>
              )}
              <div className="logout-modal-body">
                Are you sure you want to log out?
              </div>
            </div>
            {error && (
              <div style={{ color: "red", width: "100%", textAlign: "center" }}>
                {error}
              </div>
            )}
            <div className="logout-modal-button-container">
              <div
                className={`logout-cancel ${loading && "disabled-button"}`}
                onClick={() => setShowLogoutPopup(false)}
              >
                Cancel
              </div>
              <div
                className={`logout-cancel logout-btn ${loading && "disabled-button"
                  }`}
                onClick={signOutFunction}
              >
                Log out
              </div>
            </div>
          </div>
        }
      />
      <div className="header-component-left-container">
        <div
          className={`header-menu-icon-container${
            tabbarUp && !showMenu ? " header-menu-icon-container--tucked" : ""
          }`}
          onClick={isCoachingActive ? undefined : sideMenuHandle}
          style={{ opacity: isCoachingActive ? 0.5 : 1, cursor: isCoachingActive ? 'not-allowed' : 'pointer' }}
        >
          {!showMenu ? <MenuIcon /> : <Close />}
          {showMenu && (
            <MenuComponent
              closeMenu={closeMenu}
              close={() => setShowMenu(false)}
              hideRelationShipManager={window?.location?.href?.includes(
                "onboarding"
              )}
              setShowLogoutPopup={setShowLogoutPopup}
            />
          )}
        </div>
      </div>

      {headerContentRightSideContent ? (
        <div className="header-notification-container">
          {/* <div
            className="header-menu-icon-container-notification bell-icon-container"
            onClick={() => {
              setShowCalendar(!showCalendar);
              setShowMenu(false);
              setShowNotification(false);
            }}
          >
            <Calendar />
          </div>
          {showCalendar && (
            <div ref={calendarRef}>
              <ScheduleContainer
                setshowCalendar={setShowCalendar}
                setShowRescheduleModal={setShowRescheduleModal}
                setSelectedSessionId={setSelectedSessionId}
              />
            </div>
          )} */}

          {!isChatHistoryOpen && (
            <>
              <div
                className="header-menu-icon-container-notification bell-icon-container"
                onClick={isCoachingActive ? undefined : () => {
                  setShowMenu(false);
                  setShowCalendar(false);
                  setShowNotification((prev) => !prev);
                }}
                style={{ opacity: isCoachingActive ? 0.5 : 1, cursor: isCoachingActive ? 'not-allowed' : 'pointer' }}
              >
                <BellIcon />
                {notificationCount > 0 && (
                  <div className="notification-badge">{notificationCount}</div>
                )}
              </div>
            </>
          )}
          {showNotification && (
            <div ref={notificationRef}>
              <NotificationContainer
                onRouted={() => setShowNotification(false)}
                setshowNotification={setShowNotification}
                showNotification={showNotification}
                refreshUnreadCount={fetchUnreadCount}
              />
            </div>
          )}
        </div>
      ) : (
        <div></div>
      )}

      {showPopup && <ReferralPopup onClose={() => setShowPopup(false)} />}
      {showRescheduleModal && (
        <SessionSelection
          showLiveSessionModal={showRescheduleModal}
          setShowLiveSessionModal={setShowRescheduleModal}
          onClose={() => {
            setShowRescheduleModal(false);
            setSelectedSessionId(null);
          }}
          setShowCalendar={setShowCalendar}
          isReschedule={true}
          sessionId={selectedSessionId}
        />
      )}

    </div>
  );
}

export default HeaderComponent;
